import { render, staticRenderFns } from "./create_client.vue?vue&type=template&id=82262854&scoped=true"
import script from "./create_client.vue?vue&type=script&lang=js"
export * from "./create_client.vue?vue&type=script&lang=js"
import style0 from "./create_client.vue?vue&type=style&index=0&id=82262854&prod&lang=css&scoped=true"
import style1 from "./create_client.vue?vue&type=style&index=1&id=82262854&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82262854",
  null
  
)

export default component.exports